module.exports = __webpack_public_path__ + "static/media/logo1.829c4b2b.jpg";